import React, { useState, useEffect } from "react";
import {
  Shield,
  ShieldPlus,
  ShieldCheck,
  Stethoscope,
  Pill,
  PiggyBank,
  Award,
  HeartPulse,
  Gem,
  Check,
  ArrowLeft,
  ArrowRight,
  CalendarCheck,
  Receipt,
  Lock,
  Users,
} from "lucide-react";
import BuyPlan from "./PlanPurchase/BuyPlan";
import { Eyebrow, Highlight } from "./HomePage";

const TENANT_ID = "T539001XT0B";

const b = (strong, text) => ({ strong, text });

const PLATFORM_BENEFITS = [
  b("Upto 50% off", "on Diagnostic test & packages"),
  b("Upto 20% off", "on Prescribed Medicines"),
];

const INSURANCE_HEADING = "Insurance benefits being provided FREE of COST";


const PLANS = [
  {
    key: "SwasthLite",
    kicker: "Life Plan",
    name: "Swasth Life Plan (4 Members)",
    price: "₹5,000",
    gstNote: "+GST",
    gstIncluded: false,
    icon: Shield,
    benefits: [
      b("Unlimited", "Tele Doctor Consultation"),
      b("1 Credit", "In-person General Physician Consultation"),
    ],
    extraSections: [
      { heading: "Platform Benefits", items: PLATFORM_BENEFITS },
      {
        heading: INSURANCE_HEADING,
        items: [
          b("₹3 lakhs", "Accidental insurance (for primary member)"),
          b("₹500 per day", "Hospitalization for primary member for max 30 days in a year"),
          b("₹1,000 per day", "in case of ICU hospitalization for max 15 days in a year (for primary member only)"),
        ],
      },
    ],
  },
  {
    key: "SwasthLifeplus",
    kicker: "LifeCare Plan",
    name: "Swasth Life Plus Plan (4 Members)",
    price: "₹5,250",
    gstNote: "including GST",
    gstIncluded: true,
    icon: ShieldPlus,
    benefits: [
      b("Unlimited", "Tele Doctor Consultation"),
      b("1 Credit", "In-person General Physician Consultation"),
    ],
    extraSections: [
      { heading: "Platform Benefits", items: PLATFORM_BENEFITS },
      {
        heading: INSURANCE_HEADING,
        items: [
          b("₹3 lakhs", "Accidental insurance (for primary member)"),
          b("₹500 per day", "Hospitalization for primary member for max 30 days in a year"),
          b("₹1,000 per day", "in case of ICU hospitalization for max 15 days in a year (for primary member only)"),
        ],
      },
    ],
  },
  {
    key: "SWASTHOC",
    kicker: "Basic Plan",
    name: "Swasth OPD On Call (4 Members)",
    price: "₹9,999",
    gstNote: "+GST",
    gstIncluded: false,
    icon: Stethoscope,
    benefits: [
      b("Unlimited On-Call", "Doctor Consultation"),
      b("1 Credit", "In-person General Physician Consultation"),
      b("1 Credit", "At home dental scan"),
      b("1 Credit", "Virtual Diabetic Consultation"),
    ],
    extraSections: [
      { heading: "Platform Benefits", items: PLATFORM_BENEFITS },
      {
        heading: INSURANCE_HEADING,
        items: [
          b("₹5 lakhs", "Accidental insurance (for primary member)"),
          b("₹1,000 per day", "Hospitalization for primary member for max 30 days in a year"),
          b("₹2,000 per day", "in case of ICU hospitalization for max 15 days in a year (for primary member only)"),
        ],
      },
    ],
  },
  {
    key: "TreatSure",
    kicker: "Basic Plan",
    name: "Treat Sure plan (4 Members)",
    price: "₹10,499",
    gstNote: "Including GST",
    gstIncluded: true,
    icon: Pill,
    benefits: [
      b("Unlimited", "Tele Doctor Consultation"),
      b("1 Credit", "In-person General Physician Consultation"),
      b("₹500", "Pharmacy Wallet - Prescribed Medicines"),
      b("1 Credit", "At Home Dental Scan"),
      b("1 Credit", "Vitual Diabetic Consultation"),
    ],
    extraSections: [
      { heading: "Platform Benefits", items: PLATFORM_BENEFITS },
      {
        heading: INSURANCE_HEADING,
        items: [
          b("₹5 lakhs", "Accidental insurance (for primary member)"),
          b("₹1000 per day", "Hospitalization for primary member for max 30 days in a year"),
          b("₹2,000 per day", "in case of ICU hospitalization for max 15 days in a year (for primary member only)"),
        ],
      },
    ],
  },
  {
    key: "SehatSahyogi",
    kicker: "Basic Plus Plan",
    name: "Sehat Sahyogi plan (4 Members)",
    price: "₹12,599",
    gstNote: "Including GST",
    gstIncluded: true,
    icon: HeartPulse,
    benefits: [
      b("Unlimited", "Tele Doctor Consultation"),
      b("1 Credit", "In-person General Physician Consultation"),
      b("₹500", "Pharmacy Wallet - Prescribed Medicines"),
      b("1 Credit", "At Home Dental Scan"),
      b("1 Credit", "Vitual Diabetic Consultation"),
      b("1 Credit", "Mental Wellness"),
    ],
    extraSections: [
      { heading: "Platform Benefits", items: PLATFORM_BENEFITS },
      {
        heading: INSURANCE_HEADING,
        items: [
          b("₹7.5 lakhs", "Accidental insurance (for primary member)"),
          b("₹1,000 per day", "Hospitalization for primary member for max 30 days in a year"),
          b("₹2,000 per day", "in case of ICU hospitalization for max 15 days in a year (for primary member only)"),
        ],
      },
    ],
  },
  {
    key: "SwasthOPDSaverPlan",
    kicker: "Saver Plan",
    name: "Swasth OPD Saver Plan (4 Members)",
    price: "₹25,000",
    gstNote: "+GST",
    gstIncluded: false,
    icon: PiggyBank,
    benefits: [
      b("Unlimited", "Tele Doctor Consultation"),
      b("₹2,500", "Diagnostic & Radiology Wallet"),
      b("1 Credit", "In-person General Physician Consultation"),
      b("2 Credit", "Virtual Diabetes Consultation"),
      b("₹1,000", "Pharmacy Wallet - Prescribed Medicines"),
      b("1 Credit", "Ambulance (24x7 Availability)"),
      b("1 Credit", "At Home Dental Scan"),
      // b("At Discounted Prices", "Gym Membership"),
    ],
    extraSections: [
      { heading: "Platform Benefits", items: PLATFORM_BENEFITS },
      {
        heading: INSURANCE_HEADING,
        items: [
          b("₹7.5 lakhs", "Accidental insurance (for primary member)"),
          b("₹1,000 per day", "Hospitalization for primary member for max 30 days in a year"),
          b("₹2,000 per day", "in case of ICU hospitalization for max 15 days in a year (for primary member only)"),
        ],
      },
    ],
  },
  /*
  {
    key: "SwasthOPDHealthGuardPlan",
    kicker: "Health Guard",
    name: "Swasth Health Guard Plan (4 Members)",
    price: "₹25,000",
    gstNote: "Including GST",
    gstIncluded: true,
    icon: ShieldCheck,
    benefits: [
      b("Unlimited", "Tele Doctor Consultation"),
      b("1 Credit", "In-person General Physician Consultation"),
      b("₹1,000", "Pharmacy Wallet - Prescribed Medicines"),
      b("1 Credit", "Ambulance (24x7 Availability)"),
      b("At Discounted Prices", "Gym Membership"),
    ],
    extraSections: [
      {
        heading: "Insurance Benefits",
        items: [
          b("₹5 lakhs", "Accidental insurance (for All member)"),
          b("₹500 per day", "Hospitalization for primary member for max 30 days in a year"),
          b("₹1,000 per day", "in case of ICU hospitalization for max 15 days in a year (for primary member only)"),
        ],
      },
    ],
    disclaimer:
      "The Company shall not be held responsible for payments made by the customer to any third parties / any payment made by third party on behalf of the customer. HospiCash, Accidental Insurance or any cover is not available at age above 60 years.",
  },
  */
  {
    key: "SwasthOPDGrandPlan",
    kicker: "Silver Plan",
    name: "Swasth OPD Grand Plan (4 Members)",
    price: "₹35,000",
    gstNote: "+GST",
    gstIncluded: false,
    icon: Award,
    benefits: [
      b("Unlimited", "Tele Doctor Consultation"),
      b("3 Credit", "In-person General Physician Consultation"),
      b("₹5,000", "Diagnostic & Radiology Wallet"),
      b("₹2,000", "Pharmacy Wallet - Prescribed Medicines"),
      b("2 Credits", "Virtual Diabetes Consultation"),
      b("2 Credits", "Ambulance (24x7 Availability)"),
      b("1 Credits", "At Home Dental Scan"),
      // b("At Discounted Prices", "Gym Membership"),
    ],
    extraSections: [
      { heading: "Platform Benefits", items: PLATFORM_BENEFITS },
      {
        heading: INSURANCE_HEADING,
        items: [
          // b("₹1 lakhs", "Term Life insurance (for primary member only)"),
          b("₹7.5 lakhs", "Accidental insurance (for primary member)"),
          b("₹1,500 per day", "Hospitalization for primary member for max 30 days in a year"),
          b("₹3,000 per day", "in case of ICU hospitalization for max 15 days in a year (for primary member only)"),
        ],
      },
    ],
  },
  {
    key: "SwasthOPDGrandProtectPlan",
    kicker: "Advanced Plan",
    name: "Swasth OPD Grand Protect Plan (4 Members)",
    price: "₹45,000",
    gstNote: "+GST",
    gstIncluded: false,
    icon: ShieldCheck,
    benefits: [
      b("Unlimited", "Tele Doctor Consultation"),
      b("6 Credits", "In-person General Physician Consultation"),
      b("2 Credits", "Full Body Check Up (91 Parameters)"),
      b("₹10,000", "Diagnostic & Radiology Wallet"),
      b("₹2,500", "Pharmacy Wallet - Prescribed Medicines"),
      b("2 Credits", "Virtual Diabetes Consultation"),
      b("2 Credits", "Ambulance (24x7 Availability)"),
      b("2 Credits", "Mental Health Virtual Consultation"),
      b("1 Credits", "At Home Dental Scan"),
      // b("At Discounted Prices", "Gym Membership"),
    ],
    extraSections: [
      { heading: "Platform Benefits", items: PLATFORM_BENEFITS },
      {
        heading: INSURANCE_HEADING,
        items: [
          // b("₹2 lakhs", "Term Life insurance (for primary member only)"),
          b("₹10 lakhs", "Accidental insurance (for primary member)"),
          b("₹2,000 per day", "Hospitalization for primary member for max 30 days in a year"),
          b("₹4,000 per day", "in case of ICU hospitalization for max 15 days in a year (for primary member only)"),
        ],
      },
    ],
  },
  {
    key: "SwasthOPDValuePlus",
    kicker: "Advanced Value Plan",
    name: "Swasth OPD Value Plus Plan (4 Members)",
    price: "₹75,000",
    gstNote: "+GST",
    gstIncluded: false,
    icon: Gem,
    benefits: [
      b("Unlimited", "Tele Doctor Consultation"),
      b("4 Credits", "Full Body Check Up (91 Parameters)"),
      b("Unlimited", "In-person General Physician Consultation"),
      b("₹15,000", "Diagnostic & Radiology Wallet"),
      b("₹3,000", "Pharmacy Wallet - Prescribed Medicines"),
      b("5 Credits", "Virtual Diabetes Consultation"),
      b("2 Credits", "Ambulance (24x7 Availability)"),
      b("2 Credits", "At Home Dental Scan"),
      b("3 Credits", "Mental Wellness"),
      // b("At Discounted Prices", "Gym Membership"),
    ],
    extraSections: [
      { heading: "Platform Benefits", items: PLATFORM_BENEFITS },
      {
        heading: INSURANCE_HEADING,
        items: [
          // b("₹5 lakhs", "Term Life insurance (for primary member only)"),
          b("₹15 lakhs", "Accidental insurance (for primary member)"),
          b("₹3,000 per day", "Hospitalization for primary member for max 30 days in a year"),
          b("₹6,000 per day", "in case of ICU hospitalization for max 15 days in a year (for primary member only)"),
        ],
      },
    ],
  },
  /*
  {
    key: "SwasthOPDPremiumCare",
    kicker: "Advanced Premium Plan",
    name: "Swasth OPD Premium Care Plan (4 Members)",
    price: "₹75,000",
    gstNote: "+GST",
    gstIncluded: false,
    icon: Gem,
    benefits: [
      b("Unlimited", "Tele Doctor Consultation"),
      b("Unlimited", "In-person General Physician Consultation"),
      b("₹30,000", "Diagnostic & Radiology Wallet"),
      b("₹3,500", "Pharmacy Wallet - Prescribed Medicines"),
      b("6 Credits", "Virtual Diabetes Consultation"),
      b("4 Credits", "Ambulance (24x7 Availability)"),
      b("2 Credits", "At Home Dental Scan"),
    ],
    extraSections: [{ heading: "Platform Benefits", items: PLATFORM_BENEFITS }],
  },
  {
    key: "swasthOPDpremiumcareplus",
    kicker: "Advanced Golden Plan",
    name: "Swasth OPD Premium Care Plus Plan (4 Members)",
    price: "₹99,750",
    gstNote: "including GST",
    gstIncluded: true,
    icon: Gem,
    benefits: [
      b("Unlimited", "Tele Doctor Consultation"),
      b("Unlimited", "In-person General Physician Consultation"),
      b("₹30,000", "Diagnostic & Radiology Wallet"),
      b("₹3,500", "Pharmacy Wallet - Prescribed Medicines"),
      b("6 Credits", "Virtual Diabetes Consultation"),
      b("4 Credits", "Ambulance (24x7 Availability)"),
      b("2 Credits", "At Home Dental Scan"),
    ],
    extraSections: [{ heading: "Platform Benefits", items: PLATFORM_BENEFITS }],
  },
  {
    key: "SwasthOPDRoyale",
    kicker: "SwasthOPD Royale Plan",
    name: "Swasth OPD Royale Care Plan (4 Members)",
    price: "₹95,000",
    gstNote: "+GST",
    gstIncluded: false,
    icon: Gem,
    benefits: [
      b("Unlimited", "Tele Doctor Consultation"),
      b("Unlimited", "In-person General Physician Consultation"),
      b("6 Credits", "Annual Health Checkup"),
      b("₹30,000", "Diagnostic & Radiology Wallet"),
      b("₹5,000", "Pharmacy Wallet - Prescribed Medicines"),
      b("6 Credits", "Virtual Diabetes Consultation"),
      b("4 Credits", "Ambulance (24x7 Availability)"),
      b("2 Credits", "At Home Dental Scan"),
    ],
    extraSections: [
      {
        heading: "Inclusive Benefits",
        items: [
          b("Added", "Risk Assessment"),
          b("Added", "Health Reminder"),
          b("Added", "Recorded Fitness Sessions"),
        ],
      },
      { heading: "Platform Benefits", items: PLATFORM_BENEFITS },
    ],
  },
  */
];

/* ---------- Shared UI pieces ---------- */

const CARD_SHADOW = "shadow-[0_10px_40px_-20px_rgba(13,47,39,0.25)]";

const PlanIcon = ({ icon: Icon, size = "md" }) => {
  const box = size === "lg" ? "h-20 w-20 rounded-[22px]" : "h-14 w-14 rounded-2xl";
  const glyph = size === "lg" ? 34 : 24;
  return (
    <span
      className={`relative flex shrink-0 items-center justify-center ${box} bg-[#2b6347] shadow-[0_12px_24px_-10px_rgba(13,47,39,0.7),inset_0_1px_0_rgba(255,255,255,0.18)] ring-1 ring-black/10`}
    >
      <span className={`pointer-events-none absolute inset-0 ${box} bg-[radial-gradient(circle_at_30%_20%,rgba(214,234,79,0.28),transparent_60%)]`} />
      <Icon size={glyph} color="#d6ea4f" strokeWidth={1.6} className="relative" />
    </span>
  );
};

const Tick = ({ small = false }) => (
  <span
    className={`mt-px flex shrink-0 items-center justify-center rounded-full bg-[#0d2f27] ${
      small ? "h-[18px] w-[18px]" : "h-5 w-5"
    }`}
  >
    <Check size={small ? 11 : 12} color="#d6ea4f" strokeWidth={3.2} />
  </span>
);

/* Renders a benefit line: bold value + description */
const Benefit = ({ item }) => (
  <span>
    <strong className="font-semibold text-[#0d2f27]">{item.strong}</strong> {item.text}
  </span>
);

function readPlanFromHash() {
  const h = window.location.hash.replace("#", "");
  return PLANS.find((p) => p.key === h)?.key || null;
}

/* ---------- Listing ---------- */

const HIGHLIGHT_PREVIEW = 5;

function PlanListing({ onSelect }) {
  return (
    <div className="bg-[#f6f5f0] pb-20">
      {/* Intro band (sits below the fixed header) */}
      <section className="m-3 rounded-2xl bg-[#0b2a23] bg-hero-card bg-hero-grid px-4 pb-28 pt-20 sm:px-6 ">
        <div className="mx-auto max-w-3xl text-center">
          <Eyebrow tone="dark">Healthcare Package</Eyebrow>
          <h1 className="mt-[20px] mb-[0px] text-[34px] sm:text-[44px] xl:text-[52px] font-extrabold leading-[1.08] tracking-[-0.03em] text-white">
            Choose The Best Plan For You &amp; <Highlight tone="dark">Your Family</Highlight>
          </h1>
        </div>
      </section>

      {/* Cards, pulled up over the band */}
      <div className="relative mx-auto -mt-20 max-w-7xl px-4 sm:px-6 lg:-mt-24 lg:px-8">
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {PLANS.map((plan) => {
            const more = plan.benefits.length - HIGHLIGHT_PREVIEW;

            return (
              <article
                key={plan.key}
                onClick={() => onSelect(plan.key)}
                className={`group relative flex cursor-pointer flex-col rounded-[24px] bg-white p-6 ring-1 ring-black/5 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_24px_50px_-24px_rgba(13,47,39,0.45)] sm:p-7 ${CARD_SHADOW}`}
              >
                <div className="flex items-center gap-4">
                  <PlanIcon icon={plan.icon} />
                  <div className="min-w-0">
                    <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-[#1f8a4f]">
                      {plan.kicker}
                    </p>
                    <h3 className="mt-0.5 font-display text-xl font-extrabold leading-tight text-[#0d2f27]">
                      {plan.name}
                    </h3>
                  </div>
                </div>

                <div className="mt-5 flex items-baseline gap-1.5 rounded-2xl bg-[#eef6f0] px-4 py-3">
                  <span className="font-display text-3xl font-extrabold tracking-tight text-[#0d2f27]">
                    {plan.price}
                  </span>
                  <span className="ml-auto text-xs text-[#5b6b66]">{plan.gstNote}</span>
                </div>

                <ul className="mt-6 flex-1 space-y-3">
                  {plan.benefits.slice(0, HIGHLIGHT_PREVIEW).map((item, i) => (
                    <li key={i} className="flex items-start gap-3 text-[13.5px] leading-snug text-[#5b6b66]">
                      <Tick small />
                      <Benefit item={item} />
                    </li>
                  ))}
                </ul>
                {more > 0 && (
                  <p className="mt-3 pl-[30px] text-xs font-medium text-[#1f8a4f]">
                    + {more} more benefit{more > 1 ? "s" : ""}
                  </p>
                )}

                <button
                  type="button"
                  className="mt-7 inline-flex w-full items-center justify-center gap-2 rounded-full linear-block py-3 text-sm font-semibold text-white transition-colors group-hover:bg-[#1f6b45]"
                >
                  View details
                  <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
                </button>
              </article>
            );
          })}
        </div>
      </div>
    </div>
  );
}

/* ---------- Detail ---------- */

function PlanDetail({ plan, onBack, onBuy }) {
  const buy = () => onBuy(plan.key);

  const facts = [
    { icon: Users, text: "Covers 4 Members" },
    { icon: Receipt, text: plan.gstIncluded ? "Price includes GST" : "Price shown excludes GST" },
    { icon: Lock, text: "Secure payment" },
  ];

  return (
    <div className="bg-white">
      {/* Intro band (sits below the fixed header) */}
      <section className="m-3 rounded-2xl bg-[#0b2a23] bg-hero-card bg-hero-grid px-4 pb-12 pt-16 sm:px-6 lg:pb-16 lg:pt-20">
        <div className="mx-auto max-w-6xl">
          <button
            type="button"
            onClick={onBack}
            className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-sm font-semibold text-white ring-1 ring-white/15 transition-colors hover:bg-white/20"
          >
            <ArrowLeft size={16} />
            All plans
          </button>

          <div className="mt-8 flex flex-col gap-6 sm:flex-row sm:items-center">
            <PlanIcon icon={plan.icon} size="lg" />
            <div className="min-w-0">
              <Eyebrow tone="dark">{plan.kicker}</Eyebrow>
              <h1 className="mt-[16px] mb-[0px] text-[32px] sm:text-[40px] xl:text-[48px] font-extrabold leading-[1.08] tracking-[-0.03em] text-white">
                {plan.name}
              </h1>
            </div>
          </div>
        </div>
      </section>

      <div className="relative isolate pb-28 lg:pb-24">
        {/* Soft illustration behind the details so the page isn't all white */}
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-0 -z-10 bg-cover bg-center bg-no-repeat opacity-[0.2]"
          style={{ backgroundImage: "url(/assets/img/hero/bg-plan-details.png)" }}
        />
        {/* <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-0 -z-10 bg-gradient-to-b from-[#f6f5f0]/70 via-[#f6f5f0]/40 to-[#f6f5f0]/70"
        /> */}
      <div className="mx-auto grid max-w-6xl gap-8 px-4 pt-10 sm:px-6 lg:grid-cols-[minmax(0,1fr)_340px] lg:px-8 lg:pt-14">
        {/* Left: benefits */}
        <div className="min-w-0 space-y-8">

          {plan.extraSections?.length > 0 && (
            <section className={`rounded-[24px] bg-white p-6 ring-1 ring-black/5 sm:p-8 ${CARD_SHADOW}`}>
              <Eyebrow>Full plan details</Eyebrow>
              <div className="mt-5 grid gap-3 sm:grid-cols-2">
              {plan.benefits.map((item, i) => (
                <div
                  key={i}
                  className="flex items-start gap-3 rounded-2xl bg-[#eef6f0] p-4 text-sm leading-snug text-[#5b6b66] ring-1 ring-black/5"
                >
                  <Tick />
                  <Benefit item={item} />
                </div>
              ))}
            </div>

              {plan.extraSections.map((section, sectionIndex) => (
                <div key={sectionIndex} className="mt-6">
                  <div className={`mb-4 ${sectionIndex > 0 ? "border-t border-[#0d2f27]/[0.08] pt-6" : ""}`}>
                    <h2 className="font-display text-lg font-extrabold text-[#0d2f27]">{section.heading}</h2>
                  </div>

                  <ul className="space-y-3.5">
                    {section.items.map((item, itemIndex) => (
                      <li
                        key={itemIndex}
                        className="flex items-start gap-3 text-sm leading-relaxed text-[#5b6b66]"
                      >
                        <Tick small />
                        <Benefit item={item} />
                      </li>
                    ))}
                  </ul>
                </div>
              ))}

              {plan.disclaimer && (
                <p className="mt-6 border-t border-[#0d2f27]/[0.08] pt-6 text-xs leading-relaxed text-[#5b6b66]">
                  <strong>Disclaimer* </strong>
                  {plan.disclaimer}
                </p>
              )}
            </section>
          )}
        </div>

        {/* Right: sticky price summary (desktop) */}
        <aside className="hidden lg:block">
          <div className={`sticky top-28 rounded-[24px] bg-white p-7 ring-1 ring-black/5 ${CARD_SHADOW}`}>
            <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-[#1f8a4f]">
              Plan price
            </p>
            <div className="mt-2 flex items-baseline gap-1.5">
              <span className="font-display text-4xl font-extrabold tracking-tight text-[#0d2f27]">
                {plan.price}
              </span>
              <span className="text-sm text-[#5b6b66]">{plan.gstNote}</span>
            </div>

            <button
              type="button"
              onClick={buy}
              className="mt-6 inline-flex w-full items-center justify-center gap-2 rounded-full linear-block py-3.5 text-sm font-semibold text-white transition-colors hover:bg-[#1f6b45]"
            >
              Buy Now
              <ArrowRight size={16} />
            </button>

            <ul className="mt-6 space-y-3 border-t border-[#0d2f27]/[0.08] pt-6">
              {facts.map(({ icon: FactIcon, text }) => (
                <li key={text} className="flex items-center gap-3 text-sm text-[#5b6b66]">
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-[#e8f3ec] text-[#0d2f27]">
                    <FactIcon size={16} strokeWidth={1.8} />
                  </span>
                  {text}
                </li>
              ))}
            </ul>
          </div>
        </aside>
      </div>
      </div>

      {/* Mobile / tablet: price + buy bar pinned to the bottom */}
      <div className="fixed inset-x-3 bottom-3 z-40 flex items-center justify-between gap-4 rounded-2xl bg-[#0b2a23]/95 px-5 py-3 shadow-lg backdrop-blur-md lg:hidden">
        <div className="min-w-0">
          <p className="font-display text-xl font-extrabold leading-none text-[#d6ea4f]">{plan.price}</p>
          <p className="mt-1 text-xs text-white/70">{plan.gstNote}</p>
        </div>
        <button
          type="button"
          onClick={buy}
          className="inline-flex shrink-0 items-center gap-2 rounded-full bg-[#d6ea4f] px-5 py-2.5 text-sm font-bold text-[#0d2f27]"
        >
          Buy Now
          <ArrowRight size={16} />
        </button>
      </div>
    </div>
  );
}

/* ---------- Page ---------- */

export default function PlanPage() {
  const [activeKey, setActiveKey] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [planCode, setPlanCode] = useState("");

  const openBuy = (code) => {
    setPlanCode(code);
    setOpenPopup(true);
  };

  useEffect(() => {
    setActiveKey(readPlanFromHash());
    const onHash = () => setActiveKey(readPlanFromHash());
    window.addEventListener("hashchange", onHash);
    return () => window.removeEventListener("hashchange", onHash);
  }, []);

  /* Start each view (listing / a plan) from the top */
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [activeKey]);

  const selectPlan = (key) => {
    window.location.hash = key;
  };

  const goBack = () => {
    window.location.hash = "";
    setActiveKey(null);
  };

  const activePlan = PLANS.find((plan) => plan.key === activeKey);

  return (
    <>
      {activePlan ? (
        <PlanDetail plan={activePlan} onBack={goBack} onBuy={openBuy} />
      ) : (
        <PlanListing onSelect={selectPlan} />
      )}

      <BuyPlan
        planCode={planCode}
        tenantId={TENANT_ID}
        showPopUp={openPopup}
        setShowPopUp={setOpenPopup}
      />
    </>
  );
}